import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const ZodParseError = BaseErrorSchema.extend({
  errorType: z.literal('ZodParseError'),
  errorReason: z.string(),
});

export type ZodParseError = z.infer<typeof ZodParseError>;
